module.exports = __webpack_public_path__ + "static/media/banner-example.e66dd5ed.jpg";